import { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import en from '../../../lang/en-us';
import { SubmitButton } from '../../../lib/Button';

const { dashboard } = en;

type NoFoliosFoundPropsType = {
    info?: string;
    extraClass?: string;
    icon?: string;
    onClick?: null | (() => void);
};

export default function NoFoliosFound({
    info = '',
    extraClass = '',
    icon = 'folios-not-found',
    onClick = null,
}: NoFoliosFoundPropsType) {

    const message = info || dashboard.noFoliosFound;

    const [announce, setAnnounce] = useState('');

    useEffect(() => {
        // force NVDA announcement
        setAnnounce('');
        setTimeout(() => setAnnounce(message), 50);
    }, [message]);

    return (
        <div className={`folios-not-found ${extraClass}`}>
            <img src={`/images/${icon}.svg`} alt="" aria-hidden="true" />

            {/* SR-only live region */}
            <div
                aria-live="assertive"
                aria-atomic="true"
                role="alert"
                style={{
                    position: 'absolute',
                    left: '-10000px',
                    width: '1px',
                    height: '1px',
                    overflow: 'hidden'
                }}
            >
                {announce}
            </div>

            {/* visible text */}
            <p>
                {message}
            </p>

            {!!onClick && (
                <SubmitButton
                    label="Go to e-Mandate"
                    onClick={onClick}
                    style={{
                        width: '50%',
                        fontSize: '12px',
                        padding: '10px',
                        marginTop: '15px',
                        marginLeft: '25%',
                    }}
                />
            )}
        </div>
    );
}